import React from "react";
import { observer } from "mobx-react";
import { SignedEditionDndaWorkflowStateViewStore } from "../../store";
import { SignedEditionDndaWorkflowStateViewForm } from "./SignedEditionDndaWorkflowStateViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type SignedEditionDndaWorkflowStateViewProps = {
  signedEditionDndaWorkflowStateViewStore: SignedEditionDndaWorkflowStateViewStore;
};

export const SignedEditionDndaWorkflowStateView: React.FC<SignedEditionDndaWorkflowStateViewProps> =
  observer(({ signedEditionDndaWorkflowStateViewStore }) => {
    return (
      <div>
        <SignedEditionDndaWorkflowStateViewForm
          name_es={signedEditionDndaWorkflowStateViewStore.name_esValue}
          name_en={signedEditionDndaWorkflowStateViewStore.name_enValue}
          name_pt={signedEditionDndaWorkflowStateViewStore.name_ptValue}
          onPrint={(handlePrint: () => void) =>
            signedEditionDndaWorkflowStateViewStore.printSignedEditionDndaWorkflowState(
              handlePrint
            )
          }
          onCancel={() =>
            signedEditionDndaWorkflowStateViewStore.cancelSignedEditionDndaWorkflowState()
          }
          onEdit={
            signedEditionDndaWorkflowStateViewStore.isEditEnabled
              ? () =>
                  signedEditionDndaWorkflowStateViewStore.editSignedEditionDndaWorkflowState()
              : undefined
          }
        />
        <ErrorDialog
          open={signedEditionDndaWorkflowStateViewStore.errorDialogOpened}
          title={signedEditionDndaWorkflowStateViewStore.errorTitle}
          description={signedEditionDndaWorkflowStateViewStore.errorDescription}
          onClose={() =>
            signedEditionDndaWorkflowStateViewStore.closeErrorDialog()
          }
        />
      </div>
    );
  });
